import type { UserAlertsSettingsState } from "./reducer";
import { compose } from "redux";

import type { UserAlertsState } from "../userAlertsStore";

const selectUserAlertsSettings = (
  state: UserAlertsState,
): UserAlertsSettingsState => state.userAlertsSettings;

export const selectUserAlertSettings = compose(
  (state: UserAlertsSettingsState) => state.notificationSettingsWebData,
  selectUserAlertsSettings,
);

export const selectUpdateUserAlertSettings = compose(
  (state: UserAlertsSettingsState) => state.updateAlertSettingsWebData,
  selectUserAlertsSettings,
);

export const selectDeviceStatusSubscription = compose(
  (state: UserAlertsSettingsState) => state.deviceStatusSubscriptionWebData,
  selectUserAlertsSettings,
);

export const selectUpdateDeviceStatusSubscription = compose(
  (state: UserAlertsSettingsState) =>
    state.updateDeviceStatusSubscriptionWebData,
  selectUserAlertsSettings,
);
